import {
  callbackGetAddressSuggestions,
  debouncedGetAddressSuggestions
} from 'helpers/AddressHelpers';
import { debounceJukeboxRequestAction } from 'sharedActions/sharedActions';
import {
  mapDispatchNextPageWithTurndowns,
  mapDispatchToPropsAddress,
  mapStateToPropsAddress
} from 'reg_redesign/redux/connectFunctions';
import { merge } from 'lodash';
import Address from '@opploans/address-component/Address';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

const page5 = {
  defaultNextPage: 'page-6',
  pageRule: [
    {
      logic: 'eval',
      targets: ['nextPage'],
      property: 'state',
      operator: 'equal',
      triggerValue: 'WI',
      resultValue: 'page-5.1'
    }
  ],
  content: [
    configureProgressBar(18),
    configureTitle('Where do you live?'),
    {
      component: Address,
      name: 'homeAddress',
      stateToPropsOverride: mapStateToPropsAddress,
      dispatchOverride: mapDispatchToPropsAddress,
      props: {
        apiKey: window.AppConfig.smarty_api_key,
        isSmartyEnabled: true,
        isVisible: true,
        lineOneId: 'homeStreetAddress',
        lineTwoId: 'secondaryAddress',
        cityId: 'city',
        stateId: 'state',
        zipId: 'zip',
        idsToValidate: [
          'homeStreetAddress',
          'secondaryAddress',
          'city',
          'state',
          'zip'
        ],
        zipOnChange: debounceJukeboxRequestAction,
        stateOnChange: debounceJukeboxRequestAction,
        callbackGetAddressSuggestions,
        debouncedGetAddressSuggestions
      }
    },
    merge({}, nextButtonConfig('page-5'), {
      dispatchOverride: mapDispatchNextPageWithTurndowns
    })
  ]
};

export default page5;
